module.exports = __webpack_public_path__ + "img/ayun-asset-based-screens.475de0c4.png";